import styled from 'styled-components';
import retanglesBottom from '~/assets/default/retangles-login.svg';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  //background-image: url(${retanglesBottom});
  background: linear-gradient(180deg, #ff9034 0%, #ff6900 100%);

  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  overflow-x: hidden;
`;
